import { RootState } from '~/store';

export const getIsQrCodeStylesUpdating = (state: RootState) => state.anonQr.isQrCodeStylesUpdating;
